import { sumoPracticeProducts } from "../../../constants/products";

export type SumoData = {
  tours: {
    id: string;
    tabName: string;
  }[];
  headerText: {
    title: string;
    subTitle: string;
  };
  contentBlocks: {
    title: string;
    description: string;
    barTitle: string;
  }[];
  media: {
    type: "image" | "video";
    url: string;
  }[];
  mapTitle: string;
};

const data: SumoData[] = [
  {
    tours: sumoPracticeProducts.map((product) => ({
      id: product.id,
      tabName: product.name,
    })),
    headerText: {
      title: "Watch Sumo Morning Practice Tour",
      subTitle:
        "Witness the intense training and dedication of sumo wrestlers during a morning practice session.",
    },
    contentBlocks: [
      {
        title: "Morning Practice Session",
        description:
          "Experience the thrill of watching sumo wrestlers train in the early hours of the morning.",
        barTitle: "Sit down and Enjoy",
      },
      {
        title: "Guided Tour",
        description:
          "Our knowledgeable guides will provide insights into the history and traditions of sumo wrestling.",
        barTitle: "Duration: 3 hours",
      },
      {
        title: "Limited Availability",
        description:
          "Due to the exclusive nature of this tour, spots are limited. Book now to secure your place!",
        barTitle: "Bookings open",
      },
    ],
    media: [
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676374/sumo-landing-page/ae130558a6c29322c9d390f28e6ac3af.png",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676163/sumo-landing-page/c08ebdf5-57d9-4e2f-bc96-f6f56fd83f2a.webp",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676163/sumo-landing-page/4d45bef3-3120-408d-85f4-7d6ca585b9af-uozxb76v.webp",
      },

      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676164/sumo-landing-page/9c69b8ae-44ec-428b-9095-2207708ab101.jpg",
      },
    ],
    mapTitle: "Available in These Areas of Tokyo",
  },
  {
    tours: [
      {
        id: "9374c341-6d87-4064-85f2-80bdb3edfb6b",
        tabName: "Kawasaki",
      },
    ],
    headerText: {
      title: "Challenge Sumo Wrestlers",
      subTitle: "Authentic Sumo Experience in Tokyo : Enter the Sanctuary",
    },
    contentBlocks: [
      {
        title: "Train Like a Sumo",
        description:
          "Experience the actual training of sumo wrestlers in a real sumo stable",
        barTitle: "Experience",
      },
      {
        title: "Guided Tour",
        description:
          "Our knowledgeable guides will provide insights into the history and traditions of sumo wrestling.",
        barTitle: "Duration: 4 hours",
      },
      {
        title: "Sumo Style Lunch",
        description:
          "Make chicken dumplings for chanko-nabe, a dish that builds the body of a sumo wrestler, and eat them together!",
        barTitle: "Includes Lunch",
      },
    ],
    media: [
      {
        type: "video",
        url: "https://res.cloudinary.com/dbm1qiew0/video/upload/v1718676166/sumo-landing-page/753890c0-b7d7-42ac-8096-003a058ee2a8.mp4",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676161/sumo-landing-page/318da792-f8cf-4d1b-84ac-6fd4532723f7.webp",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676161/sumo-landing-page/fe673116-ca61-4e6c-9a00-e3b045eeef94.webp",
      },

      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676163/sumo-landing-page/fdfb9e24-39d5-40c6-9059-bdd6b1312f5a.webp",
      },
    ],
    mapTitle: "Located near Kawasaki Station",
  },
  {
    tours: [
      {
        id: "3e954323-fe3f-411e-955e-ca39b760883c",
        tabName: "Seat S",
      },
      {
        id: "eb27e9cc-6f1f-4f15-847c-7c174f1e7045",
        tabName: "Seat B",
      },
    ],
    headerText: {
      title: "Grand Sumo Tournament Tour with Premium Ticket in Tokyo",
      subTitle:
        "Sumo Premium Ticket Included. explore Ryogoku, the sacred place of sumo, walking tour with a local guide. Learn the history, culture, and rules of sumo to fully enjoy sumo matches in Ryogoku Kokugikan hall.",
    },
    contentBlocks: [
      {
        title: "Tokyo Grand Sumo Tournament Ticket",
        description: "2nd Floor (S) rank seat (1st ~3rd row)",
        barTitle: "Special Seats",
      },
      {
        title: "Guided Tour",
        description:
          "Our knowledgeable guides will provide insights into the history and traditions of sumo wrestling.",
        barTitle: "Duration: 4 hours",
      },
      {
        title: "Tour Photos",
        description:
          "You'll get photos taken during the tour by your guide after the tour via email.",
        barTitle: "Tour Photos",
      },
    ],
    media: [
      {
        type: "video",
        url: "https://res.cloudinary.com/dbm1qiew0/video/upload/v1718690475/sumo-landing-page/270aed23-fbc5-4231-8c9c-9240f0c87a90.mp4",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676160/sumo-landing-page/30bffb4e-f4a7-44ca-80dd-9dcf572f560d.webp",
      },
      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676161/sumo-landing-page/897dbc1f-e659-4c22-8cbd-799033874853.jpg",
      },

      {
        type: "image",
        url: "https://res.cloudinary.com/dbm1qiew0/image/upload/v1718676160/sumo-landing-page/fc09a56a-f6b5-4a44-94fd-052c7ece9571.webp",
      },
    ],
    mapTitle: "Premium seat tickets",
  },
];

export default data;
